<template>
    <LoadingStep v-if="isSubmitting" class="grow" :has-perspective="!!creation.user_basic.has_perspective_report" />
    <ProfileCreationStartRedesign
        v-else
        :viewer-name="creation.user_basic.full_name"
        :has-perspective-report="!!creation.user_basic.has_perspective_report"
        :perspective-assessment-enabled="creation.perspective_assessment_enabled"
        :perspective-report-enabled="creation.perspective_report_enabled"
        :document-upload-enabled="creation.document_upload_enabled"
        :share-back-target="shareBackTarget"
        @create-profile="handleGenerateProfile" />
    <BaseNotification v-if="generationError" theme="error" :text="generationError" hide-dismiss />
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import { type ShareBackTarget, withShareBackTarget } from "~vue/CollaborationProfile/composables/useProfileShareBack";
import BaseNotification from "~vue/components/BaseNotification.vue";
import LoadingStep from "~vue/components/ProfileWizard/LoadingStep.vue";
import ProfileCreationStartRedesign from "~vue/components/ProfileWizard/ProfileCreationStartRedesign.vue";
import { useProfileWizard } from "~vue/composables/useProfileWizard";
import type { ProfileCreationProps } from "~vue/types/profile";
import { onMounted, ref } from "vue";

const {
    creation,
    autoGenerate = false,
    shareBackTarget = null,
} = defineProps<{ creation: ProfileCreationProps; autoGenerate?: boolean; shareBackTarget?: ShareBackTarget | null }>();
const emit = defineEmits<{ submitting: [value: boolean] }>();
const isSubmitting = ref(false);
const { generateProfile, generationError } = useProfileWizard({
    isManager: !!creation.user_basic.is_manager,
    hasPerspectiveReport: !!creation.user_basic.has_perspective_report,
});

const handleGenerateProfile = async (fileIds: number[] = [], freeText?: string) => {
    if (isSubmitting.value) {
        return;
    }
    isSubmitting.value = true;
    emit("submitting", true);
    await generateProfile({ fileIds, freeText, isRecreating: false });
    if (generationError.value) {
        isSubmitting.value = false;
        emit("submitting", false);
        return;
    }
    router.visit(withShareBackTarget(creation.own_profile_url, shareBackTarget?.id));
};

onMounted(() => {
    if (autoGenerate) {
        void handleGenerateProfile();
    }
});
</script>
